import { Controller } from '@hotwired/stimulus';

export default class ToggleClassController extends Controller {
  static classes = ['name'];

  static targets = ['element'];

  on() {
    this.elementTargets.forEach((target) => {
      target.classList.add(...this.nameClasses);
    });
  }

  off() {
    this.elementTargets.forEach((target) => {
      target.classList.remove(...this.nameClasses);
    });
  }
}
